<template>
    <div>
    	<table class="room-table" cellspacing="0" v-if="!isLoading">
            <tbody>
                <tr style="text-align: left;vertical-align: top;">
                    <td class="roomType">{{rps.PriceTypeName+'&nbsp;&nbsp;'+"< " + rps.RatePlanName + " >"}}</td>
                    <td class="roomStatus">
                        <p>房态</p>
                        <p>{{inpPrice?"价格":''}}</p>
                        <p>{{inpRule?"取消规则":''}}</p>
                    </td>
                    <td :class="(getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S)?'change-room roomItem close':'change-room roomItem'" v-for="day in tableData" @click="toRoomStatusSingleEdit(day)">
                        <div v-if="day" class="roomContent">
                            <!-- <i v-if="getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S"></i> -->
                            <div v-if="day.A" style="cursor: default;">
                                <p v-if="day.S=='026001'" class="roomOpen">已开房</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose">已关房</p>
                                <p v-else class="roomWait">暂无房态</p>
                               
                            </div>
                            <div v-if="!day.A" style="cursor: default;">
                                <p v-if="day.S=='026001'" class="roomOpen">已开房</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose">已关房</p>
                                <p v-else class="roomWait">暂无房态</p>
                            </div>
                            <p>
                                <label class="size" style="cursor: pointer;">{{inpPrice?day.AP:''}}</label>
                            </p>
                           
                            <p v-show="!day.C" class="font10">
                                <label v-show="day.CD!=null&&inpRule" style="cursor: pointer;">{{day.CD>0?day.CD +'天':'当天'}}</label>
                                <label v-show="day.CT&&inpRule" style="cursor: pointer;">{{day.CT}}</label>
                            </p>
                            <p v-show="day.C&&inpRule"><span style="cursor: pointer;">不可取消</span></p>
                            <!-- <span class="day">{{getDateDay(day.PD)}}</span> -->
                        </div>
                        <div class="roomContent" v-else> </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <RoomPriceSingleEdit :cmData="cmSingleData" :rps="cmRps" @initTable="initTable"></RoomPriceSingleEdit>
 
    </div>

</template>
<script>
import RoomPriceSingleEdit from './roomPriceEdit/RoomPriceSingle.vue'


export default {
    name:'datePriceTable',
    components:{
        RoomPriceSingleEdit,
    },
    props:{
        rps:{
            type:Object,
            default:function(){
                return{}
            }
        },
        beginSlot:{
            type: String,
            default:''
        },
        inpPrice:{
            type: Boolean,
            default:true
        },
        inpRule:{
            type: Boolean,
            default:true
        },
        
    },
    data(){
        return{
            cmRps:{},
            tableData:'',
            cmSingleData: {},
            today:this.getDate(0),
            begin:this.getDate(0),
            isLoading:true
        }
    },
    watch:{
        beginSlot(val){
            this.begin = val
            this.initDate()
        },
        rps(val){
            console.log(val)
            this.cmRps=val;
            this.initTable();
        }
    },
    methods:{
        
        initDate(){
            var arr=[]
            var date =''
            for(var i = 0;i<=6; i++){
                if(i==0){
                    date = this.begin
                }else{
                    date = this.getNextDay(this.begin,i)
                }
                arr.push(date)
            }
            this.$emit('select',this.begin,arr)
            this.initTable()
        },
        //获取月份的数据
        initTable(){
            var that=this;
            var cmRps=that.cmRps;
            var params={
              hotel: cmRps.HotelId,
              room: cmRps.RoomId,
              rp: cmRps.RatePlanId,
              rate: cmRps.RateId,
              date: that.begin.replace(/-/g,''),
              endDate:that.getNextDay(that.begin,10).replace(/-/g,'')
            }
            that.isLoading = true;
            that.getRequest({
                url: that.Api.getRp,
                params: params
            }).then(res => {
                that.isLoading = false;
                if (res && res.length>0) {
                    that.tableData = res                 
                } else {
                    that.tableData='';
                    that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },

       
        //获取日期中的天
        getDateDay(date){
            var date=date;
            var day=date.split('/')[2];
            return day

        },
        //编辑单独一天的房态
        toRoomStatusSingleEdit(day){
            
            if(this.getDaysSize(this.today,day.PD)<0)return;//先判断当期日期是否可以编辑
            let Data=JSON.parse(JSON.stringify(day));
      
            if(Data.CD==null||Data.CD==''||Data.CD==0){
                Data.CD=0

            }
            if(Data.CT==null||Data.CT==''||Data.CT==0){
                Data.CT='17:00'

            }

            this.cmSingleData=Data;
            this.$nextTick(function () {
                this.$set(this.cmSingleData,'isShow',true);
            });
            
        }
    },
    mounted(){
        this.cmRps=this.rps;
        this.initDate()
    }

}
</script>












// WEBPACK FOOTER //
// src/components/roomPrice/psComponent/table.vue